import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

// ID class for project-picker
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.projects.ProjectPicker.';
  public static readonly projectNumberTitle = `${Id.prefix}projectNumberTitle`;
  public static readonly projectTitleTitle = `${Id.prefix}projectTitleTitle`;
  public static readonly clientTitle = `${Id.prefix}clientTitle`;
}

// Lang wrapper for project-picker
export class LangProjectPicker {
  private constructor() {}
  public static projectNumberTitle(): string {
    return interpolate(Id.projectNumberTitle);
  }
  public static projectTitleTitle(): string {
    return interpolate(Id.projectTitleTitle);
  }
  public static clientTitle(): string {
    return interpolate(Id.clientTitle);
  }
}

// Module registration for project-picker
export class ProjectPickerModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Table columns
    register.add(
      Id.projectNumberTitle,
      "{{glossary 'project'}} No.",
      'Title for project number column in project picker table'
    );
    register.add(
      Id.projectTitleTitle,
      "{{glossary 'project'}} Title",
      'Title for project title column in project picker table'
    );
    register.add(Id.clientTitle, "{{glossary 'client'}}", 'Title for client column in project picker table');
  }
}
